import { Handle, Position } from '@xyflow/react';

export function ActionNode({ data, targetPosition = Position.Left, sourcePosition = Position.Right }) {
  const displayName = data.name.length > 40
    ? data.name.substring(0, 37) + '...'
    : data.name;

  const multiActionCompetencyIds = data.multiActionCompetencyIds || [];
  const hasMultiActionParents = multiActionCompetencyIds.length > 0;
  const isHorizontal = targetPosition === Position.Left || targetPosition === Position.Right;

  // Check if there are single-action competencies (they use the default handle)
  const hasSingleActionParents = data.competencyIds?.some(
    id => !multiActionCompetencyIds.includes(id)
  );

  // Position handles evenly along the edge
  const getHandleStyle = (index, total, hasDefault) => {
    const totalHandles = hasDefault ? total + 1 : total;
    const startIndex = hasDefault ? index + 1 : index;
    const spacing = 100 / (totalHandles + 1);
    const position = spacing * (startIndex + 1);

    if (isHorizontal) {
      return { top: `${position}%`, transform: 'translateY(-50%)' };
    } else {
      return { left: `${position}%`, transform: 'translateX(-50%)' };
    }
  };

  const getDefaultHandleStyle = () => {
    if (!hasMultiActionParents) return {};
    const totalHandles = multiActionCompetencyIds.length + 1;
    const spacing = 100 / (totalHandles + 1);
    if (isHorizontal) {
      return { top: `${spacing}%`, transform: 'translateY(-50%)' };
    } else {
      return { left: `${spacing}%`, transform: 'translateX(-50%)' };
    }
  };

  return (
    <div
      className={`flow-node flow-node-action ${data.isMultiParent ? 'multi-parent' : ''}`}
      title={data.name}
    >
      {/* Default handle for single-action competencies */}
      {(hasSingleActionParents || !hasMultiActionParents) && (
        <Handle
          type="target"
          position={targetPosition}
          className="flow-handle"
          style={getDefaultHandleStyle()}
        />
      )}

      {/* Separate handles for multi-action competencies */}
      {multiActionCompetencyIds.map((compId, index) => (
        <Handle
          key={compId}
          type="target"
          position={targetPosition}
          id={compId}
          className="flow-handle flow-handle-multi"
          style={getHandleStyle(index, multiActionCompetencyIds.length, hasSingleActionParents)}
        />
      ))}

      {/* Source handle for connecting to entry nodes (detailed view) */}
      <Handle
        type="source"
        position={sourcePosition}
        className="flow-handle"
      />

      <div className="flow-node-content">
        <div className="flow-node-title">{displayName}</div>
        <div className="flow-node-stats">
          {data.skillCount} skills | {data.roleCount} roles
        </div>
        {data.isMultiParent && (
          <div className="flow-node-badge">
            {data.competencyIds.length} competencies
          </div>
        )}
      </div>
    </div>
  );
}
